import { RouteObject } from "react-router-dom";
import { GeneralErrorPage } from "@songtradr-sso/shared/frontend";
import { SignIn } from "./SignIn";
import { routes } from "./SignIn.Parts";

// LOADER

// WRAPPER

// ROUTE
export const SignInRouteObject: RouteObject = {
  path: routes.signIn,
  errorElement: <GeneralErrorPage />,
  Component: SignIn,
};
